import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './Box.module.scss.js';

const { componentTestLabel } = getTestLabels('Box');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Box/Box.tsx)
 *
 * @param {boolean} fullRounded - **DEPRECATED** (optional) This prop is deprecated and has no effect. It will be removed in a later version.
 * @param {boolean} thickBorder - (optional) If true, the border will be 2 pixels instead of 1.
 * @param {string} variant - (optional) One of `primary` (default), `secondary`, `neutral`, ~~`grey`~~ (deprecated alias to `neutral`), `success`, `danger` or ~~`warning`~~ (deprecated alias to `danger`).
 */
const Box = forwardRef((props, ref) => {
    const { children, className, thickBorder, variant = 'primary', ...otherProps } = props;
    const fixedVariant = variant === 'grey' ? 'neutral' : variant;
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, className: classNames(className, style['z-box'], {
            [style[`z-box--${fixedVariant}`]]: fixedVariant !== 'primary',
            [style['z-box--bold']]: thickBorder,
        }), ...otherProps, children: children }));
});
Box.displayName = 'Box';

export { Box };
//# sourceMappingURL=Box.js.map
